<template>
  <div class="tnc-body">
    <h5>{{sellerName}} Gift Card Terms and Conditions</h5>
    <p>
      These terms apply when you buy a gift card from <b>{{sellerName}}</b> through Show Me The Menu.
      By paying, you agree to them.
    </p>

    <h6>1. The seller</h6>
    <p>
      The gift card is sold by <b>{{sellerLegalName}}</b>{{tradingAs}} (the “Seller”).
      The contract is between you and the Seller, not Show Me The Menu.
    </p>
    <p v-if="addressText">
      {{addressText}}<span v-if="merchant.phoneNumber"><br/>Tel: {{merchant.phoneNumber}}</span>
    </p>
    <p>
      Show Me The Menu is a brand of Borium Studio Limited. It provides the website, payment page,
      gift card QR, email and wallet buttons only. Card payments are taken by Stripe for the Seller.
    </p>

    <h6>2. What you are buying</h6>
    <p>
      You are buying a prepaid gift card for this Seller only. The balance can be used to pay
      for goods or services at the Seller’s till or kiosk. It is not cash and cannot be withdrawn.
      It is not valid at any other business.
    </p>
    <p>
      You choose the amount when you buy, between £1 and £1,000.
      <span v-if="amountText">This purchase: <b>£{{amountText}}</b>.</span>
      The remaining balance is reduced each time the card is used.
    </p>
    <p>
      If an expiry date is shown on the card, it cannot be used after that date.
      If no expiry is shown, the card does not expire unless the Seller revokes it.
    </p>

    <h6>3. How you redeem</h6>
    <p>
      Show the gift card QR code (or wallet pass) at the Seller’s till or kiosk.
      Staff or the kiosk will take some or all of the remaining balance towards the order.
      You pay any amount above the remaining balance in the usual way.
    </p>
    <p>
      Keep the email and QR safe. Anyone who shows the QR may be able to spend the balance.
    </p>

    <h6>4. Payment, email and your card</h6>
    <p>
      Email is required. After payment we email you the card details, QR code and wallet buttons,
      and register the card to that email.
    </p>
    <p>
      Name and phone are optional. We use your details only to issue and support this gift card.
    </p>

    <h6>5. Giving the card to someone else</h6>
    <p>
      You may send the remaining balance to another person by entering their email on the gift card page.
      The card then belongs to that email. The previous wallet copies stop working.
      Only send it to someone you trust.
    </p>

    <h6>6. Refunds and cancellation</h6>
    <p>
      The gift card is prepaid. The Seller does not offer a refund of unused balance if you
      change your mind after payment, except where the law requires one.
    </p>
    <p>
      If you buy at a distance you may have a legal right to cancel within 14 days.
      That right ends once any of the balance has been spent. To ask about cancellation, contact the Seller.
    </p>
    <p>
      The Seller may revoke a gift card. Revoking cancels any remaining balance. It is not a refund.
    </p>

    <h6>7. Problems</h6>
    <p>
      If you cannot spend a valid balance, or you believe a spend was taken in error, contact the Seller.
      Show Me The Menu hosts the card record but does not decide redemption, revoke, or refunds.
    </p>
  </div>
</template>

<script>
export default {
  name: 'GiftCardTnC',
  props: {
    merchant: {
      type: Object,
      default: function() {
        return {};
      }
    },
    amount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    sellerName: function() {
      return this.merchant && this.merchant.title ? this.merchant.title : 'the restaurant';
    },
    sellerLegalName: function() {
      if (this.merchant && this.merchant.registeredTitle) {
        return this.merchant.registeredTitle;
      }
      return this.sellerName;
    },
    tradingAs: function() {
      if (this.merchant && this.merchant.registeredTitle
          && this.merchant.title && this.merchant.registeredTitle !== this.merchant.title) {
        return ', trading as ' + this.merchant.title;
      }
      return '';
    },
    addressText: function() {
      if (!this.merchant) {
        return '';
      }
      let parts = [];
      if (this.merchant.address) parts.push(this.merchant.address);
      if (this.merchant.city) parts.push(this.merchant.city);
      if (this.merchant.postCode) parts.push(this.merchant.postCode);
      return parts.join(', ');
    },
    amountText: function() {
      if (!this.amount || this.amount < 1) {
        return '';
      }
      return Number(this.amount).toFixed(2);
    }
  }
}
</script>

<style scoped>
.tnc-body {
  text-align: left;
  padding: 10px 15px 20px 15px;
  font-size: 14px;
  color: #333;
  line-height: 1.45;
}
.tnc-body h5 {
  font-weight: 700;
  margin-bottom: 12px;
}
.tnc-body h6 {
  font-weight: 700;
  margin-top: 18px;
  margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/GiftCardTnC.vue